type Props = {
  s3Url: string;
  projectName: string;
  disabled?: boolean;
  disableHover?: boolean;
};

export default function ProjectCard({
  s3Url,
  projectName,
  disabled = false,
  disableHover = false,
}: Props) {
  const base =
    "relative inline-flex rounded-lg font-medium w-full h-32 bg-center bg-cover bg-black bg-opacity-40 bg-blend-soft-light";
  const hover = disabled || disableHover ? "" : "hover:shadow-2xl";
  const cursor = disabled || disableHover ? "cursor-default" : "cursor-pointer";

  return (
    <button
      type="button"
      aria-disabled={disabled}
      disabled={disabled}
      className={`${base} ${hover} ${cursor} focus-visible:outline-none focus-visible:ring-0`}
      style={{ backgroundImage: `url(${s3Url})` }}
    >
      <div className="px-3 pt-2 pb-1 flex grow flex-col h-full justify-between w-full">
        <p className="text-left text-white leading-snug text-ellipsis overflow-clip card-title-outline">
          {projectName}
        </p>
      </div>
    </button>
  );
}
